import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { interactiveStart } from '../../actions/actions';

// const stateSlice = createSlice(videoStateSliceOptions);

/**
 * @typedef {Object} ReferenceObjectDescription
 * @property {string} video_id
 * @property {string} objectId
 * @property {string} root_id
 * @property {string} channel_id
 */

/**
 * @typedef {Object} VideoSlice
 * @property {string} id
 * @property {ReferenceObjectDescription} description
 */

/*
	TODO:
		Учитывая как именно меняется этот срез, я не совсем уверен что такая реализация оптимальная,
		если тип и айди меняется синхронно, то состояние меняется иначе
 */
export const videoReducer = combineReducers({
  id: createReducer(null, (builder) => {
    builder.addCase(interactiveStart, (state, action) => action.payload.object_id);
  }),
  description: createReducer(null, (builder) => {
    builder.addCase(interactiveStart, (state, action) => action.payload);
  }),


/*
 state: stateSlice.reducer,
  isLive: createReducer(null, {
    [updateTimer](state, action) {
      return action.payload.isLive;
    },
  }),
*/
});

/*
export const videoActions = {
  setState: stateSlice.actions.setState,
};
*/
